import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createIcon } from "@chakra-ui/react";
export var SpringLogoIcon = createIcon({
    displayName: "SpringLogoIcon",
    viewBox: "0 0 24 24 ",
    path: (_jsxs(_Fragment, { children: [_jsx("title", { children: "Spring Health Logo" }), _jsx("path", { d: "M3 24H12.2666C17.6196 24 22 20.142 22 15.4274V11H12.7334C7.37955 11 3 14.8572 3 19.5719V24Z", fill: "#329F97" }), ",", _jsx("path", { d: "M11.267 14H2V9.23125C2 4.15395 6.38017 0 11.7338 0H21V4.76798C21 9.84528 16.6198 14 11.267 14Z", fill: "#40655E" }), ","] })),
    defaultProps: {
        "aria-label": "Spring Logo Icon",
        role: "img",
    },
});
